// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__Dne4o","title_block":"style_title_block__ADw5i"};